import React from 'react';
import Footer from '../Components/Footer';
import option5 from "../Images/Option5.jpg";

const ProductPage = () =>{
    const products = {
        WindowsDoors:[
            {Product: "Option 1", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 54mm Width, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 2", 
            Face: "67mm or 93mm", 
            FHeight: "61mm", 
            FWidth:"77mm", 
            SHeight: "73mm", 
            SWidth: "85mm", 
            SWeight: "up to 180kg", 
            Glazing: "23 to 72mm", 
            Thermals: "Polyamides 40mm Width, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 4", 
            Face: "Concealed", 
            FHeight: "35mm or 59mm", 
            FWidth:"164mm", 
            SHeight: "22mm or 32mm", 
            SWidth: "62mm", 
            SWeight: "up to 1000kg", 
            Glazing: "36mm or 46mm", 
            Thermals: "Polyamides, PVC",
            Description: ["Thermally insulated sliding system.", "Ideal for projects requiring spans with minimum aluminum sight lines."],
            image: option5},
            {Product: "Option 5", 
            Face: "Concealed", 
            FHeight: "35mm or 59mm", 
            FWidth:"164mm", 
            SHeight: "67.4mm", 
            SWidth: "Contact Us", 
            SWeight: "up to 1000kg", 
            Glazing: "up to 46mm", 
            Thermals: "Polyamides, PVC",
            Description: ["Automated Version of Option 3.", "Ideal for projects requiring large spans.", "Minimal design with wide glazing surfaces."],
            image: option5},
            {Product: "Option 6", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides, PVC",
            Description: [""],
            image: option5},
            {Product: "Option 7", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 8", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 40mm Width, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 9", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 34mm Width, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 10", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 34mm Width, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 11", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 40mm Width, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 12", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 24mm Width, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 13", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 30mm Width, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 14", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 30mm Width, Kooltherm Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 15", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 30mm Width, Alumil energy bar, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 16", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides 24mm into frame, Polyamides 16mm to 24mm into the sash, PVC, Insulation Foam",
            Description: [""],
            image: option5},
            {Product: "Option 18", 
            Face: "93mm", 
            FHeight: "61mm", 
            FWidth:"91mm", 
            SHeight: "73mm", 
            SWidth: "99mm", 
            SWeight: "up to 180kg", 
            Glazing: "37 to 81mm", 
            Thermals: "Polyamides, PVC",
            Description: [""],
            image: option5},
        ]}
        const desiredProducts = products.WindowsDoors
        const productCards = desiredProducts.map((item, i) => {
            return(
                <div className="product-card-body">
                    <img src={item.image} className="image"/>
                    <h3>
                        {item.Product}
                        <br/>
                        Technical Characteristics:
                    </h3>
                    <div className="product-card-data">
                        <ul className="product-card-data-partial">
                            <li>
                                Visible Face Width: {item.Face}
                            </li>
                            <li>
                                Frame Height: {item.FHeight}
                            </li>
                            <li>
                                Frame Width: {item.FHeight}
                            </li>
                            <li>
                                Glazing: {item.Glazing}
                            </li>
                        </ul>
                        <ul className="product-card-data-partial"> 
                            <li>
                                Sash Height: {item.SHeight}
                            </li>
                            <li>
                                Sash Width: {item.SWidth}
                            </li>
                            <li>
                                Sash Weigth: {item.SWeight}
                            </li>
                            <li>
                                Thermal Insulation: {item.Thermals}
                            </li>
                        </ul>
                    </div>
                </div>
            )
        })
    

    
    return(
        <div>
            <section className="products">
                {productCards}
            </section>
            <Footer/>
        </div>
    )
}

export default ProductPage;